<template>
  <div>
    <loading v-show="showLoader" />

    <div class="ib-main-section">
      <div class="container">
        <router-link class="ib-back-btn" :to="{ name: 'Home' }">Back</router-link>
        <div class="row">
          <div class="col-md-6 pl-0">
            <div style="padding-top: 77px;">
              <h2 class="listing-page-title">Our Team</h2>
              <p class="listing-page-desc">Insurance Bazaar</p>
            </div>
          </div>
          <div class="col-md-6 in-page-infographic">
            <img class="img-fluid" alt="icon" :src="require('@/assets/images/claim-policy-right-img.svg')"/>
          </div>
        </div>
      </div>
      <div class="container article-box ">
        <div class="row">
            <div class="col-md-12 text-center">
              <h2 class="listing-page-title text-center" style="margin-bottom: 14px; font-size:2.50rem !important;"><span style="color: var(--primary-color);">Under</span><span style="color: var(--secondary-color);"> Maintenance</span></h2>
              <h4 class="in-undermaintenace-text mb-3" style="font-size: 1rem !important;">Sorry for the inconvenience. We’re performing some maintenance <br> at the moment.</h4>
              <img style="margin-bottom:0px !important"
                class="img-fluid mb-3 in-under-maintenance-img"
                src="@/assets/images/WebMaintainance.svg"
              />
            </div>
          </div>
        <div class="row d-none">
          <div class="col-12 text-center">
            <h2 class="ib-section-title wow animate__animated animate__fadeInRight pt-1 pt-sm-2">
              <span>Our</span> Team
            </h2>
          </div>
          <div class="col-12">
            <p class="our-team-desc text-center">Our Team draws on broad industry experience and networks to create the most powerful experiences for our customers.</p>
          </div>
        </div>
        <div class="row d-none">
          <div class="col-lg-4">
            <div class="team-member-box">
              <div class="member-img">
                <img class="img-fluid" alt="icon" :src="require('@/assets/images/team/nomaan-2.png')"/>
              </div>
              <div class="member-user">Co Founder</div>
              <div class="member-name">Nomaan Bin Bashir</div>
              <div class="member-desc"> 
              22+ years of experience in the Insurance, Financial Services and Telecom Sectors with Multinational Players like AIG &amp; Cable &amp; Wireless - covering Asia, Middle East, Europe &amp; Africa
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="team-member-box">
              <div class="member-img">
                <img class="img-fluid" alt="icon" :src="require('@/assets/images/team/faisal-2.png')"/>
              </div>
              <div class="member-user">Co Founder</div>
              <div class="member-name">Faisal Munir</div>
              <div class="member-desc">
                20+ years of experience in the Insurance, Financial Services and Regulatory Compliance areas with Multinational Players like AIG, covering Asia, Middle East, Europe &amp; Africa
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="team-member-box">
              <div class="member-img">
                <img class="img-fluid" alt="icon" :src="require('@/assets/images/team/asher-2.png')"/>
              </div>
              <div class="member-user">Co Founder</div>
              <div class="member-name">Asher Faisel Khan</div>
              <div class="member-desc">
                18+ years of experience in launching Successfully running systems Integration Company in Pakistan and Middle East providing Enterprise Solutions to Financial, Public, Educational and telecom sectors Focused on security, Data Centers, Unified Communication and IT Infrastructure
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'OurTeam'
  };
</script>

<style scoped>
  .ib-section-title {
    font-size: 24px !important;
  }
  .article-box p{
    font-family: "Avenir Book";
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: left;
    color: var(--text-color);
  }
  .our-team-desc{
    margin: 17px auto 40px;
    font-family: "Avenir Medium";
    font-size: 17px;
    font-weight: 500;
    line-height: 1.82;
    text-align: center;
    color: #b7b7b7;
  }
  @media(min-width:768px){
    .team-member-box {
      min-height: 454px;
    }
  }
  .team-member-box {
    width: 100%;
    min-height: 454px;
    margin: 40px 28px 0 0;
    padding: 30px;
    border-radius: 19px;
    background-color: #f9fbfc;
    text-align: center;
  }
  .member-img{
    width: 125px;
    height: 125px;
    margin: 0 auto;
  }
  .member-img img{
    width: 100%;
    height: 100%;
  }
  .member-name{
    margin: 0px auto 1px;
    font-family: "Avenir Medium";
    font-size: 20px;
    /* font-weight: 900; */
    color: #ef7c94;
  }
  .member-user{
    margin: 24px auto 4px;
    font-family: "Avenir Medium";
    font-weight: 500;
    font-size: 17px;
    text-align: center;
    color: #3d9cbd;
  }
  .member-desc{
    margin: 14px auto 0;
    font-family: "Avenir Medium";
    font-size: 16px;
    font-weight: 500;
    text-align: center;
    color: #5b6770;
  }
</style>



// WEBPACK FOOTER //
// src/views/Team.vue